window.toggleMenstrualSection = function() {
  var sexRadios = document.querySelectorAll("input[type='radio'][name$='[sex]']");
  var section = document.getElementById('ros_menstrual_history_section');
  var fields = document.querySelectorAll('.js-menstrual-field');

  if (sexRadios.length === 0) {
    var patientInfo = document.querySelector(".js-patient-info");
    if (patientInfo && patientInfo.textContent.toLowerCase().includes("female")) {
      if (section) { section.style.display = 'block'; toggleMenstrualNa(); }
    } else {
      if (section) { section.style.display = 'none'; }
      fields.forEach(function(field) {
        field.required = false;
        field.value = '';
      });
    }
    return;
  }

  var femaleRadio = document.querySelector("input[type='radio'][name$='[sex]'][value='Female']");

  if (femaleRadio && femaleRadio.checked) {
    if (section) { section.style.display = 'block'; }
    if (typeof window.initDatepickers === 'function') {
      window.initDatepickers($, $(section));
    }
    toggleMenstrualNa();
  } else {
    if (section) { section.style.display = 'none'; }
    fields.forEach(function(field) {
      field.required = false;
      field.value = '';
    });
  }
};

window.toggleMenstrualNa = function() {
  var naCheckbox = document.querySelector('.js-ros-menstrual-na');
  if (!naCheckbox) return;

  var fields = document.querySelectorAll('.js-menstrual-field');
  var asterisks = document.querySelectorAll('.js-menstrual-required-asterisk');

  fields.forEach(function(field) {
    if (naCheckbox.checked) {
      field.disabled = true;
      field.value = '';
      field.required = false;
    } else {
      field.disabled = false;
      field.required = true;
    }
  });

  asterisks.forEach(function(asterisk) {
    asterisk.style.display = naCheckbox.checked ? 'none' : 'inline';
  });
};

// Deduplicate global change listener across Turbolinks page transitions
if (!window.__rosChangeHandlerAttached) {
  window.__rosChangeHandlerAttached = true;
  document.addEventListener("change", function(e) {
    if (e.target && e.target.type === 'radio' && e.target.name && e.target.name.endsWith('[sex]')) {
      if (typeof toggleMenstrualSection === 'function') toggleMenstrualSection();
    }
    if (e.target && e.target.classList.contains('js-ros-menstrual-na')) {
      if (typeof toggleMenstrualNa === 'function') toggleMenstrualNa();
    }
  });
}

$(document).ready(function() {
  toggleMenstrualSection();
});
$(document).on('page:load', function() {
  toggleMenstrualSection();
});
